import { render } from "./slots-map.html?vue&type=template&id=3096b1c8&ts=true"
import script from "./slots-map.ts?vue&type=script&lang=ts"
export * from "./slots-map.ts?vue&type=script&lang=ts"

import "./slots-map.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__